import React, { useContext, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import { SearchContext } from 'context/SearchContext';
import { gtmPushEvent } from 'utils/gtmPushEvent';
import { getCurrentTab } from 'utils/tabsHelper';

import styles from './ReferenceReplacement.module.scss';
const cx = classNames.bind(styles);

const MAX_REFERENCE_APPEAR = 3;

const useImpressionReferenceGTM = ({ references, parentReference }) => {
  const {
    manuName,
    modelName,
    carTypeName,
    partName,
    kbaNumber,
    vinNumber,
  } = useContext(SearchContext);

  useEffect(() => {
    const currentTab = getCurrentTab();
    const eventNameMap = {
      reference: 'impressionResultByReference',
      car: 'impressionResultByModelCar',
      vin: 'impressionResultByVIN',
      kba: 'impressionResultByKBA',
    };

    references.forEach((reference) => {
      // gtm event search values
      const searchValues = Object.fromEntries(
        [
          ['carBrandManufacturer', manuName],
          ['carBrandModel', modelName],
          ['carBrandVehicle', carTypeName],
          ['product', partName],
          ['kba', kbaNumber],
          ['vin', vinNumber],
          ['reference', reference.replaceNumber],
          ['parentProductReference', parentReference],
        ].filter(([_key, value]) => value !== '')
      );

      gtmPushEvent({
        event: eventNameMap[currentTab],
        ...searchValues,
      });
    });
  }, [parentReference, references]);
};

export default function ReferenceReplacement({
  title,
  references,
  onClick,
  parentReference,
  seeMoreLink,
}) {
  const filteredReferences = useMemo(
    () => references.filter((ref) => ref.replaceArticleId),
    [references]
  );

  useImpressionReferenceGTM({
    references: filteredReferences,
    parentReference,
  });

  if (filteredReferences.length === 0) return null;

  return (
    <div className={cx('container')}>
      <p>
        <strong>{title}:</strong>
      </p>
      <ul className={cx('references-list')}>
        {filteredReferences
          .slice(0, MAX_REFERENCE_APPEAR)
          .map(({ replaceArticleId, replaceNumber }) => (
            <li key={`${replaceArticleId}-${replaceNumber}`}>
              <Link
                to={`/product/${replaceArticleId}/about`}
                className={cx('reference-pill')}
                onClick={() => onClick && onClick(replaceNumber)}
              >
                {replaceNumber}
              </Link>
            </li>
          ))}
        {filteredReferences.length > MAX_REFERENCE_APPEAR && (
          <li>
            <Link to={seeMoreLink} className={cx('reference-pill', 'see-more')}>
              ...
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/SearchItem/components/ReferenceReplacement.js